/**
 * French translations
 */
export default {
    // Auth
    'auth.sign_in': 'Se connecter',
    'auth.sign_in_to': 'Se connecter à {app}',
    'auth.enter_email_to_continue': 'Entre ton adresse e-mail pour continuer',
    'auth.email_label': 'Adresse e-mail',
    'auth.email_placeholder': 'you@example.com',
    'auth.continue': 'Continuer',
    'auth.checking': 'Vérification...',
    'auth.sign_out': 'Se déconnecter',
    'auth.signing_in': 'Connexion...',
    'auth.signed_in_redirecting': 'Connecté avec succès ! Redirection...',
    'auth.signed_in_close_tab': 'Connecté avec succès ! Tu peux fermer cet onglet.',
    'auth.check_email': 'Vérifie tes e-mails',
    'auth.sign_in_link_sent': 'Nous avons envoyé un lien de connexion à {email}',
    'auth.click_link_to_continue': 'Clique sur le lien pour continuer',
    'auth.first_signup_approval': 'Si tu t\'inscris pour la première fois, ta demande peut nécessiter une approbation avant l\'envoi du lien de connexion.',
    'auth.didnt_receive_try_again': 'Pas reçu ? Réessayer',
    'auth.click_link_to_sign_in': 'Clique sur le lien dans l\'e-mail pour te connecter.',
    'auth.resend_email': 'Renvoyer l\'e-mail',
    'auth.use_different_email': 'Utiliser une autre adresse',
    'auth.passkey_available': 'Passkey disponible',
    'auth.sign_in_with_passkey': 'Se connecter avec passkey',
    'auth.security_key_required': 'Clé de sécurité requise',
    'auth.use_security_key_to_sign_in': 'Utilise ta clé de sécurité pour te connecter à {email}',
    'auth.sign_in_with_security_key': 'Se connecter avec clé de sécurité',
    'auth.waiting_for_device': 'En attente de l\'appareil...',
    'auth.verifying': 'Vérification...',
    'auth.lost_device_access': 'Tu n\'as plus accès à ton appareil ?',
    'auth.lost_security_key_access': 'Tu n\'as plus accès à ta clé de sécurité ?',
    'auth.link_opened_different_device': 'Lien ouvert sur un autre appareil',
    'auth.enter_verification_code': 'Entre le code de vérification affiché :',
    'auth.verify_code': 'Vérifier le code',
    'auth.please_enter_email': 'Entre ton adresse e-mail',
    'auth.please_enter_valid_email': 'Entre une adresse e-mail valide',
    'auth.please_enter_6_digit_code': 'Entre le code à 6 chiffres',
    'auth.please_enter_valid_6_digit_code': 'Entre un code à 6 chiffres valide',
    'auth.session_expired': 'Session expirée. Réessaie.',
    'auth.session_expired_request_new': 'Session expirée. Demande un nouveau lien de connexion.',
    'auth.signin_replaced': 'Cette connexion a été remplacée par une nouvelle demande. Vérifie tes e-mails.',
    'auth.authentication_failed': 'Échec de l\'authentification. Réessaie.',
    'auth.failed_send_link': 'Échec de l\'envoi du lien de connexion. Réessaie.',
    'auth.failed_verify_code': 'Échec de la vérification du code. Réessaie.',
    'auth.webauthn_not_supported': 'Les clés de sécurité ne sont pas supportées dans ce navigateur',
    'auth.unexpected_error': 'Une erreur inattendue s\'est produite. Réessaie.',
    'auth.invalid_or_missing_token': 'Token de vérification invalide ou manquant',
    'auth.verification_failed': 'Échec de la vérification. Réessaie.',
    'auth.keep_signed_in_question': 'Rester connect\u00e9 ?',
    'auth.keep_signed_in_description': 'Sur un ordinateur partag\u00e9 ou public, choisis \u00ab\u202fPas maintenant\u202f\u00bb \u2014 ta session se terminera apr\u00e8s 30 minutes d\'inactivit\u00e9.',
    'auth.keep_signed_in_yes': 'Rester connecté',
    'auth.keep_signed_in_no': 'Pas maintenant',

    // Settings
    'settings.title': 'Paramètres',
    'settings.profile': 'Profil',
    'settings.profile_display_name': 'Nom d\'affichage',
    'settings.profile_display_name_placeholder': 'Entre ton nom',
    'settings.profile_display_name_help': 'Ce nom sera affiché à la place de ton e-mail',
    'settings.profile_not_set': 'Non défini',
    'settings.profile_avatar': 'Avatar',
    'settings.profile_avatar_upload': 'Télécharger',
    'settings.profile_avatar_help': 'JPG, PNG, GIF ou WebP. Max 2 Mo.',
    'settings.profile_avatar_too_large': 'La taille du fichier doit être de 2 Mo ou moins',
    'settings.profile_avatar_invalid_type': 'Le fichier doit être JPG, PNG, GIF ou WebP',
    'settings.profile_avatar_updated': 'Avatar mis à jour',
    'settings.profile_avatar_removed': 'Avatar supprimé',
    'settings.profile_avatar_remove_confirm': 'Supprimer ton avatar ?',
    'settings.profile_timezone': 'Fuseau horaire',
    'settings.profile_timezone_select': 'Sélectionner le fuseau horaire',
    'settings.profile_timezone_search': 'Rechercher des fuseaux horaires...',
    'settings.profile_updated': 'Profil mis à jour',
    'settings.language': 'Langue',
    'settings.language_description': 'Choisis ta langue préférée',
    'settings.sessions': 'Sessions',
    'settings.sessions_description': 'Gère tes sessions actives',
    'settings.security': 'Sécurité',
    'settings.security_description': 'Gère tes clés de sécurité et passkeys',

    // Dashboard
    'dashboard.title': 'Tableau de bord',
    'dashboard.welcome': 'Bienvenue, {name}',
    'dashboard.edit_profile': 'Modifier le profil',
    'dashboard.member_since': 'Membre depuis {date}',
    'dashboard.services': 'Services',
    'dashboard.account': 'Compte',
    'dashboard.organizations_title': 'Organisations',
    'dashboard.organizations_description': 'Gère tes organisations',
    'dashboard.domains_title': 'Domaines',
    'dashboard.domains_description': 'Configure les domaines et DNS',
    'dashboard.mailboxes_title': 'Boîtes mail',
    'dashboard.mailboxes_description': 'Comptes e-mail et stockage',
    'dashboard.aliases_title': 'Alias',
    'dashboard.aliases_description': 'Règles de redirection',
    'dashboard.settings_title': 'Paramètres',
    'dashboard.settings_description': 'Profil et sécurité',
    'dashboard.support_title': 'Support',
    'dashboard.support_description': 'Contacter le support',

    // Support
    'support.title': 'Support',
    'support.description': 'Tu as une question ou besoin d\'aide ? Envoie-nous un message et nous répondrons à {email}. Si tu préfères être contacté à une autre adresse ou souhaites être rappelé, merci de le préciser dans ton message.',
    'support.organization': 'Organisation',
    'support.no_organization': 'Demande générale (aucune organisation)',
    'support.organization_help': 'Facultatif. Sélectionne si ta demande concerne une organisation spécifique.',
    'support.subject': 'Sujet',
    'support.message': 'Message',
    'support.message_placeholder': 'Décris ta question ou ton problème...',
    'support.send': 'Envoyer',
    'support.sending': 'Envoi en cours...',
    'support.sent': 'Message envoyé',
    'support.sent_description': 'Nous avons reçu ton message et nous reviendrons vers toi.',
    'support.send_another': 'Envoyer un autre message',
    'support.fields_required': 'Le sujet et le message sont obligatoires.',
    'support.send_error': 'Impossible d\'envoyer le message. Réessaie.',

    // Common
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.add': 'Ajouter',
    'common.remove': 'Retirer',
    'common.confirm': 'Confirmer',
    'common.ok': 'OK',
    'common.close': 'Fermer',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.success': 'Succès',

    // Errors
    'error.generic': 'Une erreur s\'est produite. Réessaie.',
    'error.network': 'Erreur réseau. Vérifie ta connexion.',
    'error.unauthorized': 'Tu n\'es pas autorisé à effectuer cette action.',
    'error.not_found': 'La ressource demandée est introuvable.',

    // Admin forward conversion
    "admin.forward_conversion.title": "Convertir un transfert en alias de boîte mail",
    "admin.forward_conversion.button": "Convertir",
    "admin.forward_conversion.description": "Convertis un transfert en alias si sa destination est une boîte mail active de cette organisation. L’adresse et son historique sont conservés.",
    "admin.forward_conversion.empty": "Aucun transfert compatible. La destination doit être une boîte mail active de cette organisation, sans alias existant vers cette boîte pour la même adresse.",
    "admin.forward_conversion.search": "Rechercher des adresses...",
    "admin.forward_conversion.confirm": "Convertir {email} en alias de la boîte mail {destination} ? L’alias restera lié à cette boîte si son adresse e-mail change.",
    "admin.forward_conversion.success": "Transfert converti en alias de boîte mail",
    "admin.forward_conversion.failed": "Échec de la conversion",
    "admin.forward_conversion.stale": "Ce transfert ne peut plus être converti. Recharge la page du domaine.",
    "admin.forward_conversion.invalid": "address_id et mailbox_id doivent être des entiers positifs",
    "admin.forward_conversion.event": "Transfert converti en alias de boîte mail",
} as const;
